<template>
  <div class="accordion" role="tablist">
    <h2 class="text-center mb-4 pb-2 text-primary fw-bold">FAQ</h2>
    <h4 class="text-center">Find the answers for the most frequently asked questions below</h4>
    <b-card no-body class="mb-1">
      <b-card-header header-tag="header" class="p-1" role="tab">
        <b-button block v-b-toggle.accordion-1 variant="info">Is the application free to use?</b-button>
      </b-card-header>
      <b-collapse id="accordion-1" visible accordion="my-accordion" role="tabpanel">
        <b-card-body>
          <b-card-text>
            Yes! Kind of, the managing of contacts, organizations/groups and integration with twilio is totaly free!
            The only cost is sending text messages using the twilio service. That cost is paid directly to twilio.
          </b-card-text>
        </b-card-body>
      </b-collapse>
    </b-card>

    <b-card no-body class="mb-1">
      <b-card-header header-tag="header" class="p-1" role="tab">
        <b-button block v-b-toggle.accordion-22 variant="info">Do you support twilio whatsapp broadcast?</b-button>
      </b-card-header>
      <b-collapse id="accordion-22" accordion="my-accordion" role="tabpanel">
        <b-card-body>
          <b-card-text>
          <strong>Yes!!!</strong> we now have integration with whatsapp through twilio. You must first configure whatsapp as a sender with one of your
            phone numbers. You can then use whats app as a sender. You will need to enable whatsapp from the ward configuration/settings
            page. You then need to toggle contacts that you want the application to use whatsapp as a delivery mechanism. You can then
            start sending messages through whats app. Please note there is some waiting for messages to be approved by meta before
            they can be delivered to the recipients. After a message has been delivered to all contacts the template used will be purged from
            twilio/whatsapp. This is to adhere to the max number of message templates of 6000 max. the Ward Pager app idea has always
            been to use messages only once so there is no need to keep a history of templates used in whatsapp.
          </b-card-text>
        </b-card-body>
      </b-collapse>
    </b-card>

    <b-card no-body class="mb-1">
      <b-card-header header-tag="header" class="p-1" role="tab">
        <b-button block v-b-toggle.accordion-12 variant="info">How do Organizations/Groups work?</b-button>
      </b-card-header>
      <b-collapse id="accordion-12" visible accordion="my-accordion" role="tabpanel">
        <b-card-body>
          <b-card-text>
            There are Groups/Organizations that are created by default when a ward is onboarded. However you can customize and create your own groups and
            target those groups when sending text messages. See Tutorial on creating custom organizations and how the application
            uses them. <br/> <b-button info :href="pdfOrganizationLink">Read Organization/Group Tutorial</b-button>
          </b-card-text>
        </b-card-body>
      </b-collapse>
    </b-card>

    <b-card no-body class="mb-1">
      <b-card-header header-tag="header" class="p-1" role="tab">
        <b-button block v-b-toggle.accordion-2 variant="info">What are the twilio costs?</b-button>
      </b-card-header>
      <b-collapse id="accordion-2" accordion="my-accordion" role="tabpanel">
        <b-card-body>
          <b-card-text>
            This varies depending on how many contacts you are sending messages to and also how long are you text messages are.
            We have tried our best to estimate and guess the cost before sending the message. We have a preview option that will allow you
            to preview the cost before sending. That way you can edit messages to be more cost effective.
          </b-card-text>
        </b-card-body>
      </b-collapse>
    </b-card>

    <b-card no-body class="mb-1">
      <b-card-header header-tag="header" class="p-1" role="tab">
        <b-button block v-b-toggle.accordion-3 variant="info">Can you receive inbound messages in the application?</b-button>
      </b-card-header>
      <b-collapse id="accordion-3" accordion="my-accordion" role="tabpanel">
        <b-card-body>
          <b-card-text>
            Yes, there will be instructions sent to you on how to connect twilio inbound messages and forward them to
            the app. This way you have 1 place to view outbound/inbound messages. <br/>
            <b-button info :href="pdfTwilioConfigLink">Read Twilio Config Tutorial</b-button>
          </b-card-text>
        </b-card-body>
      </b-collapse>
    </b-card>

    <b-card no-body class="mb-1">
      <b-card-header header-tag="header" class="p-1" role="tab">
        <b-button block v-b-toggle.accordion-4 variant="info">Can you import a spreadsheet of contacts?</b-button>
      </b-card-header>
      <b-collapse id="accordion-4" accordion="my-accordion" role="tabpanel">
        <b-card-body>
          <b-card-text>
            Yes, there is an import tool you can use to import a max of 200 contacts at a time. If you have 400 contacts
            do 2 spreadsheet imports. <br/>
             <b-button info :href="pdfImportRecordsLink">Read Import Contact Tutorial</b-button>
          </b-card-text>
        </b-card-body>
      </b-collapse>
    </b-card>

    <b-card no-body class="mb-1">
      <b-card-header header-tag="header" class="p-1" role="tab">
        <b-button block v-b-toggle.accordion-5 variant="info">Is there a limit of how many contacts you can have?</b-button>
      </b-card-header>
      <b-collapse id="accordion-5" accordion="my-accordion" role="tabpanel">
        <b-card-body>
          <b-card-text>
            Currently we haven't yet reached a limit yet. The only constraint is you must load contacts in batches of 200.
          </b-card-text>
        </b-card-body>
      </b-collapse>
    </b-card>

    <b-card no-body class="mb-1">
      <b-card-header header-tag="header" class="p-1" role="tab">
        <b-button block v-b-toggle.accordion-6 variant="info">What about Security and permissions?</b-button>
      </b-card-header>
      <b-collapse id="accordion-6" accordion="my-accordion" role="tabpanel">
        <b-card-body>
          <b-card-text>
            Each ward has it's own separated space in the app. When someone signs up a new ward is created and users are
            assigned to a ward. Users can't not see each others ward contacts. This is super important because each ward
            has it's own twilio account and phone number and must be isolated at all times.
          </b-card-text>
        </b-card-body>
      </b-collapse>
    </b-card>

    <b-card no-body class="mb-1">
      <b-card-header header-tag="header" class="p-1" role="tab">
        <b-button block v-b-toggle.accordion-7 variant="info">Are there any email notifications?</b-button>
      </b-card-header>
      <b-collapse id="accordion-7" accordion="my-accordion" role="tabpanel">
        <b-card-body>
          <b-card-text>
            When you have enabled to receive messages in the application for your user, you will receive an email and then
            a user can take any action if necessary.
          </b-card-text>
        </b-card-body>
      </b-collapse>
    </b-card>

    <b-card no-body class="mb-1">
      <b-card-header header-tag="header" class="p-1" role="tab">
        <b-button block v-b-toggle.accordion-8 variant="info">Can contacts opt-out to receive text messages?</b-button>
      </b-card-header>
      <b-collapse id="accordion-8" accordion="my-accordion" role="tabpanel">
        <b-card-body>
          <b-card-text>
            Yes if a user replies STOP to a message send by your ward twilio will flag as unsubscribed phone number. When you send
            a message to this contact twilio will notify the app and in response the application will unsubscribe and disable the
            contact. This contact will not receive any more messages. If at a later time they op-in then the user will be re-enabled
            and will continue to receive messages.
          </b-card-text>
        </b-card-body>
      </b-collapse>
    </b-card>

    <b-card no-body class="mb-1">
      <b-card-header header-tag="header" class="p-1" role="tab">
        <b-button block v-b-toggle.accordion-9 variant="info">Is there a twilio discount to send messages?</b-button>
      </b-card-header>
      <b-collapse id="accordion-9" accordion="my-accordion" role="tabpanel">
        <b-card-body>
          <b-card-text>
          No, unfortunately there are not discounts. However if you reference other wards you may receive credits from twilio. Look
          into the twilio referral program.
          </b-card-text>
        </b-card-body>
      </b-collapse>
    </b-card>

    <b-card no-body class="mb-1">
      <b-card-header header-tag="header" class="p-1" role="tab">
        <b-button block v-b-toggle.accordion-10 variant="info">Is there going to be a mobile app?</b-button>
      </b-card-header>
      <b-collapse id="accordion-10" accordion="my-accordion" role="tabpanel">
        <b-card-body>
          <b-card-text>
          At this time no, the app works well on mobile browsers/phones. But maybe in the future.
          </b-card-text>
        </b-card-body>
      </b-collapse>
    </b-card>

    <b-card no-body class="mb-1">
      <b-card-header header-tag="header" class="p-1" role="tab">
        <b-button block v-b-toggle.accordion-11 variant="info">Is there mult-language support?</b-button>
      </b-card-header>
      <b-collapse id="accordion-11" accordion="my-accordion" role="tabpanel">
        <b-card-body>
          <b-card-text>
          Yes but very limited, It's mainly used to generate greetings and auto response. but currently we support
          <ul>
            <li>English</li>
            <li>Spanish</li>
            <li>Portuguese</li>
          </ul>
          </b-card-text>
        </b-card-body>
      </b-collapse>
    </b-card>

    <b-card no-body class="mb-1">
      <b-card-header header-tag="header" class="p-1" role="tab">
        <b-button block v-b-toggle.accordion-21 variant="info">Twilio/Carriers are filtering my messages Error 30007?</b-button>
      </b-card-header>
      <b-collapse id="accordion-21" accordion="my-accordion" role="tabpanel">
        <b-card-body>
          <b-card-text>
            <strong>Because of carriers policies it may be best to switch and use whatsapp if most of your contacts are on the platform</strong><br/>
          As of recently carriers have begun clamping down on spam texts and robo texts. This is good for people that don't want
          unsolicited text messages. It does however pose a problem for us trying to communicate with contacts/members. A new feature
          at your ward settings where you can now toggle the rate that you send messages through twilio. We have found this to be effective
          on having your messages deliver. Previously you were able to just send bulk amount of messages without any problems. Now because
          of carrier filters some messages may get stuck. If you are having this problem then please try enabling Throttling at the ward settings.
          When enabled you have two options
          <ul>
            <li><strong>Interval Minutes</strong> - This is how often should the app release messages to twilio</li>
            <li><strong>Max Segments</strong> - This more than likely will not correlate with contact messages unless your sending 1 segment per contact</li>
          </ul>
          <strong>Segments</strong><br/>
          Depending on how many characters your message will be to your contacts it will be divided into segments. The application will try it's best to
          calculate the segments per contact and keep track of them. Once you reach the Max Segments threshold it will stop and reschedule to send at the
          next interval set. So if 5 minutes it will schedule the message to be re-processed in the next 5 minutes. So plan large groups to take some time
          to process all contacts when throttle is enabled. <br/>
          An alternate solution may be to upgrade your number to a toll free number. However that does require filling out forms and costs $2 per month to lease
          that number as of this writing.
          </b-card-text>
        </b-card-body>
      </b-collapse>
    </b-card>

  </div>
</template>
<script>
export default {
  name: 'About',
  data () {
      return {
          pdfImportRecordsLink: require("@/assets/pdfs/importing-records.pdf"),
          pdfTwilioConfigLink: require("@/assets/pdfs/twilio-and-ward-notification-pager.pdf"),
          pdfOrganizationLink: require("@/assets/pdfs/organization-groups.pdf"),
      items: [
        {
          text: 'Features',
          to: { name: 'features' }
        },
        {
          text: 'Request Demo',
          to: { name: 'contact' }
        },
        {
          text: 'Log In',
          to: { name: 'login' },
        },
        {
          text: 'FAQ',
          to: { name: 'about' },
        },
      ]
      }
  },
  computed: {},
  mounted() {},
  methods: {}
}
</script>
